import React from 'react';
import './aboutUs.css'
const AboutUs = ({banner,leftImg,rightImg,leftText,rightText}) => {
  return (
    <>
    <div className="banner">
      <img src={banner} alt="Right"  />
    </div>
   <div className='aboutUsContainer text-center'>
    
    <div className='aboutUsText'><p>{leftText}</p></div>
    <div className="rightImg">
      <img src={rightImg} alt="Right"  />
    </div>
    <div className="leftImg">
      <img src={leftImg} alt="Left"  />
    </div>
    <div className='aboutUsText'>{rightText}</div>

    

   </div>
   </>
  );
};

export default AboutUs;